const RectangleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23">
    <path stroke="#A1A4A9" fill="none" d="M3.499 3.499h16v16h-16v-16z" />
  </svg>
);

export default RectangleIcon;
